'use strict'
// TODO костыль только из-за того что все скрипты подключаются везде.
if (window.location.pathname === '/order/') {
    function installmentCalculatorFlag(flag) {
        const submitButton = document.querySelector('.cart_final_checkout > [type="submit"]')
        if (!submitButton.classList.contains('loading')) {
            submitButton.classList.add('loading')
            submitButton.setAttribute('disabled', '')
        }
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.onreadystatechange = function () {
            if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
                const response = JSON.parse(xmlHttp.responseText)
                Object.entries(response).forEach(([key, value]) => {
                    const e = document.getElementById(key)
                    if (e) {
                        e.innerText = value
                    }
                })
                if (submitButton.classList.contains('loading')) {
                    submitButton.classList.remove('loading')
                    submitButton.attributes.removeNamedItem('disabled')
                }
            }
        }
        xmlHttp.open('POST', BX.message('SITE_DIR') + 'ajax/')
        xmlHttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
        xmlHttp.send(JSON.stringify({
            INSTALLMENT_CALCULATOR: flag,
            controller: 'order_update',
        }))
    }

    // Получаем все радиобаттоны с именем "payment"
    const paymentRadios = document.querySelectorAll('input[name="payment"]')

    // Переменная для хранения предыдущего состояния data-installment
    let previousIsInstallment = false

    // Инициализация при загрузке страницы:
    // Проверяем, какой радиобаттон выбран по умолчанию
    document.addEventListener('DOMContentLoaded', () => {
        const initialCheckedRadio = document.querySelector('input[name="payment"][checked]')
        if (initialCheckedRadio) {
            // Устанавливаем previousIsInstallment на основе начального выбранного радиобаттона
            previousIsInstallment = initialCheckedRadio.dataset.installment === 'true'
            // Вызываем функцию с соответствующим флагом для инициализации состояния
            installmentCalculatorFlag(previousIsInstallment)
        } else {
            // Если по какой-то причине ни один радиобаттон не выбран по умолчанию,
            // инициализируем как false (или как вам нужно по умолчанию)
            installmentCalculatorFlag(false)
        }
    })


    // Добавляем слушатель события 'change' к каждому радиобаттону
    paymentRadios.forEach(radio => {
        radio.addEventListener('change', (event) => {
            const currentRadio = event.target
            const currentIsInstallment = currentRadio.dataset.installment === 'true'

            // Проверяем, изменилось ли состояние data-installment
            if (currentIsInstallment !== previousIsInstallment) {
                installmentCalculatorFlag(currentIsInstallment)
                previousIsInstallment = currentIsInstallment // Обновляем предыдущее состояние
            }
        })
    })
}